import { render, staticRenderFns } from "./SchoolUniform.vue?vue&type=template&id=cfc66a48&scoped=true&"
import script from "./SchoolUniform.vue?vue&type=script&lang=js&"
export * from "./SchoolUniform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfc66a48",
  null
  
)

export default component.exports